module.exports = __webpack_public_path__ + "static/media/jet.a855a931.jpg";